import $services from "../services";
import formsStore from "@/stores/forms.store";
import Field from "@/models/field.model";
import {TYPE_SELECT, TYPE_CHECKBOX} from "@/models/field.model";
import Value from "../models/value.model";
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        fields: [],
        conditions: [],
        pins: [],
    },
    getters: {
        getPins: state => state.pins,
        getVisibleFieldsForGroup: state => group_id => {
            return state.fields.filter(field => field.group_id === group_id && field.type !== 'pin')
        },
        getFieldsForRequest: state => {
            const request = [];

            state.fields
                .filter(field => !!field.is_visible)
                .forEach(field => {
                    request.push({
                        id: field.id,
                        version: field.version,
                        value: field.value.value
                    })
                });

            return request;
        },
        isSubmitable: state => {
            return state.fields.some(field => field.isSubmitable)
        },
    },
    mutations: {
        setConditions: (state, payload) => state.conditions = payload,
        setFields: (state, payload) => state.fields = payload,
        setValue: (state, payload) => {
            let fieldKey = state.fields.findIndex(field => field.id === payload.field_id);
            state.fields[fieldKey].value = payload.value;
        },
        setPins: (state, payload) => state.pins = payload,
    },
    actions: {
        loadStore(context, form) {
            const fields = [];
            const conditions = [];
            const pins = [];

            form.groups.forEach((group) => {
                group.fields.forEach((field) => {

                    if (field.type === 'pin') {
                        pins.push(field);
                    }

                    let visibleDefault = true;
                    let value = new Value();
                    if (field.conditions) {
                        field.conditions.forEach((condition) => {
                            // we don't support booking and historic conditions here for now
                            if (condition.is_historic || condition.calendar_id || condition.service_group || condition.service_set_id) {
                                return;
                            }

                            // we support has_request and product conditions for tips display terms
                            const appointment = formsStore.getters.getAppointment(formsStore.state);
                            visibleDefault = !condition.is_include;

                            if (condition.has_request) {
                                if (appointment) {
                                    visibleDefault = condition.is_include
                                } else {
                                    visibleDefault = !condition.is_include;
                                }
                            }

                            if (condition.product_id) {
                                let includesProduct = false;
                                if (appointment && (appointment.products.length > 0 || appointment.tips.length > 0)) {
                                    includesProduct = appointment.products.some(p => p.product_id === condition.product_id);
                                    includesProduct = includesProduct || appointment.tips.some(p => p.product_id === condition.product_id);
                                }
                                if (includesProduct) {
                                    visibleDefault = condition.is_include
                                } else {
                                    visibleDefault = !condition.is_include
                                }
                            }

                            condition['conditional_id'] = field.field_id;
                            condition['conditional_type'] = 'field';
                            conditions.push(condition);
                        });
                    }

                    field['is_visible'] = visibleDefault;

                    if (field.type === TYPE_CHECKBOX) {
                        value.value = {};
                        field.options.forEach((option, optionKey) => {

                            value.value[optionKey] = null;

                            let optionVisibleDefault = true;

                            if (option.is_default) {
                                value.value[optionKey] = option.id
                            }

                            if (field.value && field.value.find(el => el === option.id)) {
                                value.value[optionKey] = option.id
                            }

                            if (option.conditions) {
                                option.conditions.forEach((condition) => {
                                    condition['conditional_id'] = option.id;
                                    condition['conditional_type'] = 'option';
                                    conditions.push(condition);
                                    optionVisibleDefault = !condition.is_include;
                                });
                            }

                            Vue.set(option, 'is_visible', optionVisibleDefault)
                        })
                    }

                    if (field.type === TYPE_SELECT) {
                        value.value = [];

                        const isMultiple = field.options.some(o => !o.is_exclusive);

                        field.options.forEach(option => {
                            if (option.is_default) {
                                if (isMultiple) {
                                    value.value.push(option.id)
                                } else {
                                    value.value = option.id
                                }
                            }

                            if (field.value && field.value.find(el => el === option.id)) {
                                if (isMultiple) {
                                    value.value.push(option.id)
                                } else {
                                    value.value = option.id
                                }
                            }

                            let optionVisibleDefault = true;

                            if (option.conditions) {
                                option.conditions.forEach((condition) => {
                                    condition['conditional_id'] = option.id;
                                    condition['conditional_type'] = 'option';
                                    conditions.push(condition);
                                    optionVisibleDefault = !condition.is_include;
                                });
                            }

                            Vue.set(option, 'is_visible', optionVisibleDefault)
                        })
                    }

                    if (field.text) {
                        value.value = null;
                        if (field.text.default) {
                            value.value = field.text.default
                        }
                        if (field.value) {
                            value.value = field.value
                        }
                    }

                    if (field.textarea) {
                        value.value = null;
                        if (field.textarea.default) {
                            value.value = field.textarea.default
                        }
                        if (field.value) {
                            value.value = field.value
                        }
                    }

                    if (field.datetime) {
                        value.value = null;
                        if (field.datetime.default) {
                            value.value = field.datetime.default
                        }

                        if (field.value) {
                            value.value = field.value
                        }
                    }

                    if (field.photo) {
                        if (field.value) {
                            value.value = field.value
                        }
                    }

                    field['value'] = value;
                    field['group_id'] = group.id;

                    fields.push(new Field(field));

                });
            });

            context.commit('setPins', pins);
            context.commit('setFields', fields);
            context.commit('setConditions', conditions);
        },
        saveValue(context, {fieldId, value}) {
            context.commit('setValue', {
                field_id: fieldId,
                value: value
            });

            const processedFields = $services.conditions.process(context.state.conditions, context.state.fields);
            context.commit('setFields', processedFields);

        }
    }
}